module.exports = __webpack_public_path__ + "img/hotelFamily-7.4ccacd95.jpg";